import { render, staticRenderFns } from "./EnrollmentsView.vue?vue&type=template&id=ccedc01a"
import script from "./EnrollmentsView.vue?vue&type=script&lang=js"
export * from "./EnrollmentsView.vue?vue&type=script&lang=js"
import style0 from "./EnrollmentsView.vue?vue&type=style&index=0&id=ccedc01a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports